import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=16c183d0"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=16c183d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports